<div class="wrapper">
  <app-project-preview-loading
    [show]="projectPreviewIsLoading$ | async"
    [text]="'The project is being loaded...'"
  ></app-project-preview-loading>
  <div class="page-header flex-row gap-8">
    <a [routerLink]="['/', 'home']">
      <img
        src="assets/inwedio-logo.svg"
        alt="Inwedio"
        class="logo pointer"
        style="height: 24px"
      />
    </a>
    <div class="proj-label">{{ projectLabel$ | async }}</div>
  </div>
  <div class="content" *ngIf="!(projectPreviewIsLoading$ | async)">
    <div class="project-overview">
      <div class="status" *ngIf="loading && !errorMsg">Loading…</div>
      <div class="error" *ngIf="errorMsg">{{ errorMsg }}</div>

      <div class="slides" *ngIf="!loading && !errorMsg">
        <ng-container *ngIf="slides$ | async as slides">
          <div style="text-align: center; font-size: 16px; margin-bottom: 32px">
            Thank you for the submission!<br />
            We will get back to you soon.
          </div>
          <div class="slide" *ngFor="let f of slides">
            <div class="slide-inner">
              <ng-container *ngIf="previewOf(f) as p">
                <div class="text" *ngIf="p.text as t">{{ t }}</div>

                <div class="thumbnails" *ngIf="p.images?.length">
                  <img
                    *ngFor="let id of p.images"
                    class="thumbnail"
                    [src]="s3Url(id)"
                    alt="image"
                  />
                </div>

                <div class="thumb video" *ngIf="p.video">
                  <video
                    [src]="s3Url(p.video)"
                    muted
                    playsinline
                    controls
                  ></video>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
